import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Podere della Quercia: pulsanti "Aggiungi al carrello" delle sezioni su misura.
 * Aggiunge l'articolo senza lasciare la pagina e avvisa il tema, che apre e aggiorna il carrello a cassetto.
 * Uso: <button data-pdq-add="ID_VARIANTE">…</button> dentro un form verso /cart/add (se lo script non parte, il form funziona lo stesso).
 */
async function aggiungi(btn) {
  const id = btn.dataset.pdqAdd;
  if (!id || btn.dataset.pdqBusy) return;
  btn.dataset.pdqBusy = '1';
  btn.setAttribute('aria-busy', 'true');

  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    const sezioni = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    if (sezioni.length) body.append('sections', sezioni.join(','));

    let url = Theme.routes.cart_add_url;
    if (!url.endsWith('.js')) url += '.js';
    const risposta = await fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body,
    }).then((r) => r.json());

    const carrello = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } }).then((r) =>
      r.json()
    );

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrello),
      detail: {
        items: carrello.items,
        source: 'pdq',
        sourceId: 'pdq',
        itemCount: 1,
        sections: risposta.sections,
        didError: Boolean(risposta.status),
      },
    });
  } catch (errore) {
    deferred.reject(errore);
    // Se qualcosa va storto, l'acquisto non si perde: si passa dal carrello classico.
    const form = btn.closest('form');
    if (form) form.submit();
  } finally {
    delete btn.dataset.pdqBusy;
    btn.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-pdq-add]') : null;
  if (!btn) return;
  event.preventDefault();
  aggiungi(btn);
});
